import { Component, HostListener, Input } from '@angular/core';
import { SelectCityService } from '../../../shared-services/select-city/select-city.service';

@Component({
  selector: 'app-header-agent',
  templateUrl: './header-agent.component.html',
  styleUrl: './header-agent.component.scss'
})
export class HeaderAgentComponent {
  @Input() auth = false;
  menuVisible = false;

  constructor(private cityService: SelectCityService) {}

  toggleMenu() {
    this.menuVisible = !this.menuVisible;
  }
  openSelectCity(): void {
    this.cityService.openSelectCity();
  }

  isFixed = false;
  isHidden = false;
  lastScrollTop = 0;
  headerHeight = 100;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > this.headerHeight) {
      this.isFixed = true;
      this.isHidden = currentScroll > this.lastScrollTop;
    } else {
      this.isFixed = false;
      this.isHidden = false;
    }
    this.lastScrollTop = currentScroll;
  }
}
